module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Book.c2bd1161.woff2";